const GoogleClientId = '53658718375-punsso6gdqo3bsmqgcd62fe1qtabc8fu.apps.googleusercontent.com'
// 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
export default GoogleClientId
